// Router.js
import {Routes, Route, Navigate, useLocation} from "react-router-dom";
import LoginPage from "./auth/LoginPage";
import { useApp } from "./Contex";
import Dashboard from "./Routes/Dashboard";
import LayoutWithSidebar from "./components/LayoutWIthSidebar";
import Menues from "./Routes/Menues";
import {useEffect} from "react";
import SpecificMenu from "./Routes/SpecificMenu";
import LocationSelect from "./auth/LocationSelect";
import Orders from "./Routes/Orders";
import Cache from "./Routes/Cache";
import Config from "./Routes/Config";
import Hours from "./Routes/Hours";
import Vouchers from "./Routes/Vouchers";
import {checkRights} from "./api/api";
import TempPage from "./components/TempPage";
import Zones from "./Routes/Zones";
import DemoPage from "./Routes/DemoPage";
import UsersPage from "./Routes/UsersPage";
import AccountPage from "./Routes/AccountPage";
import AccountSettings from "./Routes/AccountSettings";
import {AppearancePage} from "./Routes/Appearance";

export default function AppRouter() {
    const { getToken, getSid, setPermissions, refresh } = useApp();
    const location  = useLocation()
    const allowed = {
        "/login": true,
        "/location": true,
        "/": true,
    };

    function checkPermissions() {
        const page = location.pathname
        checkRights(page).then((res) => {
            const {read, write} = res?.permissions ?? {}
            if (!read && !write && allowed[page]) {
                setPermissions({read: true, write: false});
            } else {
                setPermissions(res.permissions);
            }
        });
    }

    useEffect(() => {
        checkPermissions();
    }, [location.pathname]);

    return (
        <Routes>
            {!getToken ? (
                <>
                    <Route path="/login" element={<LoginPage />} />
                    <Route path="*" element={<Navigate to="/login" />} />
                </>
            ) : !getSid ? (
                <>
                    <Route path="/location" element={<LocationSelect />} />
                    <Route path="*" element={<Navigate to="/location" />} />
                </>
            ) : (
                    <Route element={<LayoutWithSidebar />}>
                        <Route path="/" element={<Dashboard />} />

                        <Route path="/menu">
                            <Route index element={<Menues />} />                    {/* /menu */}
                            <Route path=":slug" element={<SpecificMenu />} />       {/* /menu/:slug */}
                        </Route>
                        <Route path="/order" element={<Orders/>}/>
                        <Route path="/cache" element={<Cache />} />
                        <Route path="/config" element={<Config/>}/>
                        <Route path="/hours" element={<Hours/>}/>
                        <Route path="/vouchers" element={<Vouchers/>}/>
                        <Route path="/zones" element={<Zones/>}/>
                        <Route path="/appearance" element={<AppearancePage/>}/>
                        {/*<Route path="/demo" element={<DemoPage/>}/>*/}
                        <Route path="/users" element={<UsersPage/>}/>
                        <Route path="/account" element={<AccountPage/>}/>
                        <Route path="/account/settings" element={<AccountSettings/>}/>
                        <Route path="*" element={<Navigate to="/" />} />
                    </Route>
            )}
        </Routes>

    );
}
